import React, { useRef, useState } from "react";
import HomeData from "../../../data/home.json";
import SectionTitle from "../../../components/section-title";
import SwiperCore, { Autoplay, Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import PropTypes from "prop-types";

const NewsContainer = ({ classOption = "mt-10 mt-lg-0" }) => {
    SwiperCore.use([Autoplay, Navigation]);

    const swiperRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(true);

    const swiperOption = {
        loop: true,
        speed: 2000,
        slidesPerView: 1,
        spaceBetween: 30,
        autoplay: {
            delay: 500, // ❗ increase delay (500ms is too fast)
            disableOnInteraction: false,
        },
        breakpoints: {
            320: { slidesPerView: 1 },
            480: { slidesPerView: 1 },
            640: { slidesPerView: 4 },
            768: { slidesPerView: 4 },
            992: { slidesPerView: 4 },
        },
    };

    const toggleAutoplay = () => {
        if (!swiperRef.current) return;

        if (isPlaying) {
            swiperRef.current.autoplay.stop();
        } else {
            swiperRef.current.autoplay.start();
        }
        setIsPlaying(!isPlaying);
    };

    return (
        <div className={`brand-section y-background-color ${classOption}`}>
            <div className="container">
                <div className="row mb-5">
                    <div className="col-xl-12 col-lg-12 mx-auto text-center">
                        <SectionTitle
                            classOption="title-section text-center mb-5"
                            subTitle=""
                            title="<span class='text-primary text-decoration-underline fst-italic'><a href='news'>NeoGrowth</a></span> in News"
                            excerptClassOption="null"
                            excerpt=""
                        />
                    </div>
                </div>

                <Swiper
                    className="brand-carousel mb-n7"
                    {...swiperOption}
                    onSwiper={(swiper) => (swiperRef.current = swiper)}
                >
                    {HomeData[1].news?.map((single, key) => (
                        <SwiperSlide key={key}>
                            <a
                                href={single.link}
                                rel="noreferrer"
                                target="_blank"
                            >
                                <img
                                    className="home-banner-shape"
                                    src={single.image}
                                    alt="News item"
                                />
                            </a>
                        </SwiperSlide>
                    ))}
                </Swiper>
                <div className="d-flex justify-content-center mt-10">
                    <button
                        onClick={toggleAutoplay}
                        aria-label={
                            isPlaying ? "Pause news slider" : "Play news slider"
                        }
                        title={isPlaying ? "Pause" : "Play"}
                        className="btn-primary btn-hover-primary d-flex justify-content-center align-items-center"
                        style={{
                            width: "50px",
                            height: "50px",
                            borderRadius: "50%",
                            border: "none",
                        }}
                    >
                        <i
                            className={isPlaying ? "fa fa-pause" : "fa fa-play"}
                            aria-hidden="true"
                        ></i>
                    </button>
                </div>
            </div>
        </div>
    );
};

NewsContainer.propTypes = {
    classOption: PropTypes.string,
};

export default NewsContainer;
